/* ap-cart-totals.js */
(() => {
  const $ = (s, r=document) => r.querySelector(s);

  // --- money formatter
  const money = c =>
    (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : ('$' + (c/100).toFixed(2));

  // --- write numbers into footer
  function paint(before, now){
    const save = Math.max(0, before - now);
    const nowEl    = $('#ap-total-now');
    const beforeEl = $('#ap-total-before');
    const saveEl   = $('#ap-total-save');
    const dataEl   = $('#ap-totals-data');

    if (nowEl) nowEl.textContent = money(now);

    if (beforeEl){
      if (save > 0){ beforeEl.textContent = money(before); beforeEl.style.display = 'inline'; }
      else { beforeEl.style.display = 'none'; }
    }

    if (saveEl){
      if (save > 0){ saveEl.textContent = 'You save ' + money(save); saveEl.style.display = 'inline'; }
      else { saveEl.style.display = 'none'; }
    }

    if (dataEl){
      dataEl.dataset.before = before;
      dataEl.dataset.now    = now;
      dataEl.dataset.save   = save;
    }
  }

  async function refresh(){
    try{
      const res = await fetch('/cart.js?ts=' + Date.now(), {
        headers: { 'Accept':'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!res.ok) return;
      const cart = await res.json();

      // NOW = final price after all discounts
      const now = cart.total_price || 0;

      // SAVE = Shopify's authoritative total discount (covers auto + line item + code)
      const save = cart.total_discount || 0;

      // BEFORE = always "now + save" as baseline
      let before = now + save;

      // If Shopify also provides a bigger original_total_price, prefer that
      if (typeof cart.original_total_price === 'number' && cart.original_total_price > before) {
        before = cart.original_total_price;
      }

      paint(before, now);

    }catch(e){ /* silent */ }
  }

  // --- debounce
  let t; const queue = (ms=80)=>{ clearTimeout(t); t=setTimeout(refresh, ms); };

  // --- events that must update totals
  const events = [
    'cart:updated','cart:refresh','cart:change',
    'ajaxProduct:added','shipping:estimated',
    'shopify:section:load','shopify:section:select','shopify:section:deselect'
  ];
  events.forEach(ev => document.addEventListener(ev, () => queue(30)));

  // --- qty inputs / +/- inside drawer (delegated)
  document.addEventListener('input', (e)=>{
    if (!e.target.closest('#cart-drawer')) return;
    if (e.target.matches('[data-quantity-input], input[name^="updates"], input[type="number"]')) queue(180);
  }, true);
  document.addEventListener('change', (e)=>{
    if (!e.target.closest('#cart-drawer')) return;
    if (e.target.matches('[data-quantity-input], input[name^="updates"], input[type="number"]')) queue(120);
  }, true);
  document.addEventListener('click', (e)=>{
    const hit = e.target.closest('#cart-drawer [data-action="increase"], #cart-drawer [data-action="decrease"], #cart-drawer .qty__button, #cart-drawer .quantity__button, #cart-drawer button[name="plus"], #cart-drawer button[name="minus"]');
    if (hit) queue(150);
  }, true);

  // --- when drawer is shown, refresh once
  const drawer = $('#cart-drawer');
  if (drawer){
    new MutationObserver(()=>{
      if (drawer.getAttribute('aria-hidden') === 'false') queue(40);
    }).observe(drawer, { attributes:true, attributeFilter:['aria-hidden'] });
  }

  // --- first paint using Liquid values (if present), then refresh
  document.addEventListener('DOMContentLoaded', ()=>{
    const d = $('#ap-totals-data');
    if (d) paint(+d.dataset.before || 0, +d.dataset.now || 0);
    queue(60);
  });
})();